import { ItemMiddleAttrListDataSet, TableDataColumn } from '@mri/types';

export function tableGetMiddleClass(prop: ItemMiddleAttrListDataSet, column: TableDataColumn): string {
  if (typeof column.getMiddleClass === 'function') return column.getMiddleClass(prop);

  return '';
}